import Swiper from "swiper";

const swiper = new Swiper('.swiper', {
    loop: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        addIcons: true,
    },
});

const swiperArrowLeft = document.getElementById("swiperArrowLeft");
const swiperArrowRight = document.getElementById("swiperArrowRight");

const LAST_PHOTO_INDEX = 4;

swiperArrowLeft.addEventListener("click", () => {
    if (swiper.activeIndex <= 0) {
        swiper.slideTo(LAST_PHOTO_INDEX);
    } else {
        swiper.slideTo(swiper.activeIndex - 1);
    }
})
swiperArrowRight.addEventListener("click", () => {
    if (swiper.activeIndex >= LAST_PHOTO_INDEX) {
        swiper.slideTo(0);
    } else {
        swiper.slideTo(swiper.activeIndex + 1);
    }
})

const openModal = (modalId, index) => {
    const modal = document.getElementById(modalId);

    if (modalId === 'modalGallery') {
       swiper.slideTo(index);
    }

    modal.classList.add('modal--visible');
};

const closeModal = (modalId) => {
    const modal = document.getElementById(modalId);

    modal.classList.remove('modal--visible');
}

window.openModal = openModal;
window.closeModal = closeModal;

const phoneInput = document.getElementById('phoneInput');

phoneInput.addEventListener('input', function(e) {
    let value = e.target.value.replace(/\D/g, '');

    if (!value.startsWith('7') && value.length > 0) {
        value = '7' + value;
    }

    let formattedValue = '+7';
    if (value.length > 1) {
        formattedValue += ' (' + value.substring(1, 4);
    }
    if (value.length >= 5) {
        formattedValue += ') ' + value.substring(4, 7);
    }
    if (value.length >= 8) {
        formattedValue += '-' + value.substring(7, 9);
    }
    if (value.length >= 10) {
        formattedValue += '-' + value.substring(9, 11);
    }

    e.target.value = formattedValue;
});

phoneInput.addEventListener('keydown', event => {
    if (event.key === 'Backspace') {
        setTimeout(() => {
            let value = event.target.value.replace(/\D/g, '');
            if (value.length <= 1) {
                event.target.value = '+7';
            }
        }, 0);
    }
});

const form = document.getElementById('form');
form.addEventListener('submit', async event => {
    event.preventDefault();

    const errorMessageParagraph = document.getElementById('errorMessage');
    errorMessageParagraph.classList.remove('form_error-message--visible');

    const url = 'https://hook.eu2.make.com/ail9sap2h30r7w67965m5hyv9h674xyc';

    const payload = {
        name: document.getElementById('nameInput').value,
        surname: document.getElementById('surnameInput').value,
        phone: document.getElementById('phoneInput').value,
        email: document.getElementById('emailInput').value,
    }

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'x-make-apikey': 'a6b5c485-b9d3-4eb3-add5-21f5512cbd92',
        },
        body: JSON.stringify(payload),
    })

    if (response.ok) {
        closeModal('modalForm');
    } else {
        errorMessageParagraph.classList.add('form_error-message--visible');
    }
});

function initClearButtons() {
  const inputs = document.querySelectorAll('.input');
  
  inputs.forEach(input => {
    const clearButton = input.parentElement.querySelector('.input-clear');
    
    const updateClearButton = () => {
      if (input.value.trim() !== '') {
        clearButton.style.display = 'flex';
      } else {
        clearButton.style.display = 'none';
      }
    };
    
    input.addEventListener('input', updateClearButton);
    
    clearButton.addEventListener('click', () => {
      input.value = '';
      input.focus();
      clearButton.style.display = 'none';
      
      input.dispatchEvent(new Event('input'));
    });
    
    updateClearButton();
  });
}

document.addEventListener('DOMContentLoaded', initClearButtons);

const originalOpenModal = window.openModal;
window.openModal = function(modalId, index) {
  originalOpenModal(modalId, index);
  
  if (modalId === 'modalForm') {
    setTimeout(initClearButtons, 100);
  }
};